import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';

export class InitServicesAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        await this.installer.initServices();
    }

    getName(): string {
        return 'InitServicesAct';
    }
}